// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; Powered by ANTI-AI</p>
    </footer>
  );
};

export default Footer;
